import { render, staticRenderFns } from "./ManagerWindowView.vue?vue&type=template&id=1b08d61d&scoped=true&"
import script from "./ManagerWindowView.vue?vue&type=script&lang=js&"
export * from "./ManagerWindowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b08d61d",
  null
  
)

export default component.exports